<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col cols="12" class="mb-4">
                <h2 slot="header" class="mb-0">รายละเอียดพนักงานขับรถ</h2>
              </b-col>
            </b-row>
            <b-form @submit="onSubmit">
              <ValidationObserver ref="observer">
                <b-row>
                  <b-col lg="12">
                    <b-tabs v-model="tabIndex" content-class="mt-3" fill class="tab-manage-driver">
                      <TabPersonal :driverDetails="driverDetails" />
                      <TabCar :driverDetails="driverDetails" />
                      <!-- <b-tab title="เอกสารเงินเดือน"> </b-tab> -->
                    </b-tabs>
                    <hr class="my-3" />
                    <b-row class="justify-content-between" v-if="tabIndex === 0">
                      <b-col cols="4">
                        <base-button
                          type="secondary"
                          block
                          @click="
                            $router.push({
                              name: 'manageDriver',
                            })
                          "
                        >
                          ย้อนกลับ
                        </base-button>
                      </b-col>
                      <b-col cols="4">
                        <b-button 
                          type="submit" 
                          variant="primary"
                          block
                        >
                          บันทึก
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </ValidationObserver>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import driverServices from "@/api/driver.service.js";
import TabPersonal from "@/components/Driver/Tab/Personal.vue"
import TabCar from "@/components/Driver/Tab/Car.vue"

export default {
  components: { TabPersonal, TabCar, ValidationObserver },
  props: {},
  data() {
    return {
      driverDetails: {
        driverLicenses: {
          license_type: null,
          license_number: null,
          license_start_date: null,
          license_end_date: null
        },
        vehicle: {
          drive_system: null,
          plate: null,
          province: null,
          brand: null,
          year_created: null,
          engine_type: null,
          engine_size: null,
          vehicleCategory: null
        }
      },
      tabIndex: 0
    };
  },
  created() {},
  methods: {
    async getDriver() {
      try {
        const res = await driverServices.getDriverDetailsById(
          { id: this.$route.params.id }
        );

        const data = res.data.data;
        this.driverDetails = {
          ...data,
          driverLicenses: data.driverLicenses ? data.driverLicenses : {
            license_type: null,
            license_number: null,
            license_start_date: null,
            license_end_date: null
          },
          vehicle: data.vehicle ? data.vehicle : {
            drive_system: null,
            plate: null,
            province: null,
            brand: null,
            year_created: null,
            engine_type: null,
            engine_size: null,
            vehicleCategory: null
          }
        };

      } catch (err) {}
      
    },
    async onSubmit(event) {
      event.preventDefault();
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
          return;
      }

      const { 
        id,
        email, 
        password, 
        firstname, 
        lastname, 
        phonenumber, 
        address,
        sub_district,
        district,
        province,
        postal_code,
        driverLicenses 
      } = this.driverDetails
      
      const itemPayload = {
        driver_id: id,
        email,
        password,
        firstname,
        lastname,
        phonenumber,
        address,
        sub_district,
        district,
        province,
        postal_code,
        driver_license: {
          license_number: driverLicenses.license_number,
          license_type: driverLicenses.license_type,
          license_end_date: driverLicenses.license_end_date,
          license_start_date: driverLicenses.license_start_date
        },
      }

      try {
        const response = await driverServices.updateDriver(itemPayload)

        modalSuccess(this.$bvModal, 'อัพเดทข้อมูลสำเร็จ').then( () => {
          this.$router.push({
            name: "manageDriver",
          });
        })
    
      } catch (err) {
        modalError(this.$bvModal, "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
  },
  mounted() {
    this.getDriver();
  },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
